module.exports = __webpack_public_path__ + "img/point.95f94d13.png";